import React, { useState } from "react"
import { List, ListItem, IconButton, Typography, Grid } from "@material-ui/core"
import { CloseIcon, Edit, Slash } from "@iconsGallery"
import _ from "lodash"
import { FormfacetUI } from "./form"
import { formInput } from "./fixture"
import { useFacetUIContentStyles } from "./styles"
import { useFacetUIViewState } from "./state"
import * as Utils from "@utils"
import * as Features from "@features"
import styled from "styled-components"
import * as Adm from "@adm"
import * as QA_Automation from "@qaAutomation"

const ListWrapper = styled(List)`
  &.list-split {
    display: flex;
    flex-direction: initial;
    flex-wrap: wrap;
  }
`
const ListItemWrapper = styled(ListItem)`
  &.list-split-sub {
    width: 50%;
  }
  &.makeStyles-listItem-34 {
    height: 50px;
    padding: 20px;
    align-items: center;
    border-bottom: 1px solid #e5e5e5 !important;
    padding-left: 0px;
  }
`
const ListItemHeaderWrapper = styled(ListItem)`
  &.list-split-sub {
    width: 50%;
  }
  &.makeStyles-listItem-34 {
    height: 50px;
    padding: 20px;
    align-items: center;
    border-bottom: 0em solid rgba(0, 0, 0, 0.1);
    padding-left: 0px;
  }
`

function View(props) {
  const {
    listColumnSplit = false,
    edit: facetEdit = false,
    facetData = [],
    facetSetData = () => "",
    keyPath = "id",
    valuePath = "value",
    isEditMode = true,
    setAnyChange = () => {},
    t,
    testIdLabel = "sample"
  } = props || {}
  const classes = useFacetUIContentStyles()
  const {
    edit,
    setEdit,
    collapseOpen,
    setCollapseOpen,
    data,
    setData,
    expanded,
    setExpanded,
  } = useFacetUIViewState({ defaultData: facetData })

  const [alert, setAlert] = useState(false)
  const [alertMessage, setAlertMessage] = useState("")
  const [alertType, setAlertType] = useState("")

  let testIDKit = QA_Automation?.doAddOnTestIdCommonFacetUIKit
  
  React.useEffect(() => {
    setData(facetData)
  }, [facetData])
  React.useEffect(() => {}, [data])

  const doDataUpdate = (item) => {
    setData([...item])
    facetSetData([...item])
  }

  const deleteData = (id, keypath) => {
    setAlert(false)
    let newItem = data.filter((_item) => {
      return _item[keypath] !== id
    })
    setData(newItem)
    facetSetData(newItem)
    doDataUpdate(newItem)
    setAnyChange(true)
  }

  const formSubmit = (values, { resetForm }) => {
    setAlert(false)
    const adapter = {
      [keyPath]: values.id,
      [valuePath]: values.value,
    }
    const DataKit = [adapter, ...data]
    const isDuplicate = Utils.JSUtils.isDuplicateObject(DataKit, keyPath)
    if (isDuplicate) {
      setAlertType("error")
      setAlertMessage(t("DUPLICATE_ATTRIBUTE_VALUE_PAIRS"))
      setAlert(true)
    } else {
      doDataUpdate(DataKit)
      resetForm()
      setAnyChange(true)
    }
  }

  const formStateProps = {
    data,
    keyPath: "id",
    valuePath: "value",
    setData,
    onSubmit: formSubmit,
    ...formInput,
  }

  const ListItemKit = ({ list, valuePath = "value", keyPath = "id" }) => {
    const classes = useFacetUIContentStyles()
    function isOdd(num) {
      return num % 2
    }

    function isEven(num) {
      if (num % 2 === 0) {
        return 1
      } else {
        return 0
      }
    }
    return (
      <Grid container xs={12} sm={12} md={12} lg={12} direction="row">
        <div
          style={{ flex: 1, padding: "0px", paddingTop: "0px", width: "100%" }}
        >
          <ListWrapper
            className={`cls-listwrapper-kit ${
              listColumnSplit === true ? "list-split" : ""
            } ${classes.listWrapper}`}
          >
            {listColumnSplit === false && !Utils.JSUtils.isEmpty(list) && (
              <Grid
                container
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                direction="row"
                style={{
                  padding: "15px 0px",
                  width: "100%",
                  background: "#f1f1f1",
                }}
              >
                <Grid item sm={6} xs={6} md={6} lg={6}>
                  <Typography
                    style={{
                      paddingLeft: "16px",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                     {...testIDKit(`${testIdLabel}-name-label`)}
                  >
                    {t("NAME")}
                  </Typography>
                </Grid>
                <Grid item sm={6} xs={6} md={6} lg={6}>
                  <Typography
                    style={{
                      paddingLeft: "16px",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                    {...testIDKit(`${testIdLabel}-value-label`)}

                  >
                    {t("VALUE")}
                  </Typography>
                </Grid>
              </Grid>
            )}

            {!Utils.JSUtils.isEmpty(list) ? (
              list.map((header, index) => (
                <ListItemWrapper
                  key={`ListKeyKit-${index}`}
                  className={`${classes.listItem} ${
                    listColumnSplit === true ? "list-split-sub" : ""
                  } cls-listitemwrapper`}
                  listColumnSplit={listColumnSplit}
                  style={{
                    paddingTop: "0px !important",
                    paddingBottom: "0px !important",
                    paddingRight: "0px",
                    border: "1px solid rgba(0, 0, 0, 0.1)",
                    borderBottom:
                      listColumnSplit && index === list.length - 2
                        ? isOdd(index) + " solid rgba(0, 0, 0, 0.1)"
                        : "0px",
                    borderTop: "1px solid rgba(0, 0, 0, 0.1)",
                    borderLeft: "0px",
                    borderRight: listColumnSplit
                      ? isEven(index) + " solid rgba(0, 0, 0, 0.1)"
                      : "0px",
                    paddingLeft: "0px",
                  }}
                >
                  {!isEditMode ? (
                    <>
                      <Grid
                        container
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        direction="row"
                        style={{ padding: "15px 0px", width: "100%" }}
                      >
                        <Grid item sm={6} xs={6} md={6} lg={6}>
                          <ListItem>
                            <Typography
                              style={{
                                fontSize: "14px",
                                fontWeight: "500",
                                width: "260px",
                              }}
                              {...testIDKit(`${testIdLabel}-name-input`)}
                            >
                              {_.get(header, keyPath, "")}
                            </Typography>
                          </ListItem>
                        </Grid>
                        <Grid item sm={6} xs={6} md={6} lg={6}>
                          <ListItem>
                            <Typography
                              style={{ fontSize: "14px", fontWeight: "400" }}
                               {...testIDKit(`${testIdLabel}-value-input`)}
                            >
                              {_.get(header, valuePath, "")}
                            </Typography>
                          </ListItem>
                        </Grid>
                      </Grid>
                    </>
                  ) : (
                    <Grid
                      container
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      direction="row"
                      style={{ padding: "15px 0px", width: "100%" }}
                    >
                      <Grid
                        item
                        lg={6}
                        md={6}
                        style={{
                          width: "50%",
                          borderRight: "1px solid rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <Typography
                         {...testIDKit(`${testIdLabel}-edit-${_.get(header, keyPath, "")?.replaceAll(" ", "").toLocaleLowerCase()}-input`)}
                          style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            marginTop: "14px",
                            paddingLeft: "16px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {_.get(header, keyPath, "")}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        style={{
                          height: "50px",
                          width: "50%",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography
                          style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            marginTop: "14px",
                            paddingLeft: "16px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                           {...testIDKit(`${testIdLabel}-edit-${_.get(header, valuePath, "")?.replaceAll(" ", "").toLocaleLowerCase()}-input`)}
                        >
                          {_.get(header, valuePath, "")}
                        </Typography>
                        {!facetEdit && (
                          <IconButton
                           {...testIDKit(`${testIdLabel}-edit-delete-button`)}
                            onClick={() => {
                              deleteData(_.get(header, keyPath, ""), keyPath)
                              // setAnyChange(true)
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        )}
                      </Grid>
                    </Grid>
                  )}
                </ListItemWrapper>
              ))
            ) : (
              <Features.NoRecordFound />
            )}
          </ListWrapper>
        </div>
      </Grid>
    )
  }

  const renderList = ({ facetEdit }) => {
    const renderViewlist = () => (
      <div
        className={`${classes.listProperty} makeStyles-listProperty-support`}
        style={{ width: "100%" }}
      >
        <ListItemKit list={data} keyPath={keyPath} valuePath={valuePath} />
      </div>
    )
    return facetEdit === false ? (
      <div>
        <FormfacetUI {...formStateProps} />
        {renderViewlist()}
      </div>
    ) : (
      renderViewlist()
    )
  }

  return (
    <div>
      {alert ? (
        <Adm.SnackBar open={true} message={alertMessage} type={alertType} />
      ) : null}
      {renderList({ facetEdit })}
    </div>
  )
}
export { View }
export default View
